import { CampaignModelMapper } from "features/campaign/domain/models/campaignModel";
import KroModal from "features/components/modals/kroModal";
import VanityUrlShareDetails from "./vanityUrlShareDetails";
import useFetchCampaign from "features/campaign/presentation/hooks/useFetchCampaign";

const CustomizeCampaignLinkSuccessModal = ({ isOpen, onClose, campaign }:
    { isOpen: boolean, onClose: () => void, campaign: CampaignModelMapper | undefined }) => {

    const { data: latestCampaign } = useFetchCampaign(campaign?.id ?? "");

    return <KroModal maxWidth={608} maxHeight={466} isOpen={isOpen} className=" px-0 py-0" showCloseButton={true} onClose={onClose} >
        <div className="flex flex-col gap-4">
            <div className="gap-2 flex flex-col items-center justify-center">
                <img src="/assets/icons/CheckCircleGreen.svg" className="h-[96px] w-[96px]" alt="customize-campaign-link-success" />
                <p className="text-neutral-900 font-semibold text-[16px] lg:text-[24px] leading-[120%] tracking-[-1.5%]">Link Created</p>
                <p className="text-neutral-600 font-normal text-[14px] text-center lg:text-[16px] leading-[100%] tracking-[-0.6%]">Your custom campaign link has been created successfully.</p>

            </div>
            <div className="mt-4 flex flex-col gap-2 items-start">
                <VanityUrlShareDetails vanityUrl={latestCampaign?.vanityUrl ?? campaign?.vanityUrl ?? ""} />
            </div>
        </div>
    </KroModal>;
};

export default CustomizeCampaignLinkSuccessModal;